module.exports = __webpack_public_path__ + "img/title-1.cd80a0a8.png";